import { ActionTypes } from '@src/redux/actions';
import { DefaultStateTypes } from './loaderReducer.types';
import { LoaderDispatchTypes } from '@src/redux/actions/loader/loaderActions.types';

const defaultState: DefaultStateTypes = {
  loadedAssets: [],
  expectedAssets: [],
};

const userLocationReducer = (state = defaultState, action: LoaderDispatchTypes) => {
  switch (action.type) {
    case ActionTypes.LOAD_SVG_START:
      return {
        ...state,
        expectedAssets: state.expectedAssets.includes(action.payload)
          ? state.expectedAssets
          : [...state.expectedAssets, action.payload],
      };
    case ActionTypes.LOAD_SVG_COMPLETE:
      return {
        ...state,
        loadedAssets: state.loadedAssets.includes(action.payload)
          ? state.loadedAssets
          : [...state.loadedAssets, action.payload],
      };
    default:
      return state;
  }
};

export default userLocationReducer;
